import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { IMovimentosPorAno } from "../../../../../types/api/cadastros/detalhar-publico";
import { useMemo } from "react";
import { Line } from "react-chartjs-2";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { TableSimples } from "../../../../../components/BasicComponents/DisplayDados/TableSimples";
import { formatarValorMonetario } from "../../../../../helpers/masks";

export default function DialogDetalhe({
    open,
    data,
    handleClose
}: DialogDetalheProps) {

    const labels = useMemo(() => (data.map(item => item.ano)), [data]);

    const options = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 2,
        plugins: {
            legend: {
                position: 'bottom' as const,
            }
        },
        elements: {
            line: {
                tension: 0.4
            }
        }
    }), []);

    const dataGrafico = useMemo(() => ({
        labels,
        datasets: [
            {
                label: 'Valor anual',
                data: data.map(item => item.valor_total), // Valores maiores para pedidos
                borderColor: '#4B89DC',
                backgroundColor: 'rgba(75, 137, 220, 0.1)',
                fill: true
            }
        ],
    }), [labels, data]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            maxWidth='md'
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Detalhes últimas compras</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '200px' }}>
                    <Line options={options} data={dataGrafico} />
                </Box>
                <TableSimples
                    headers={[
                        { label: "Ano" },
                        { label: "Valor", numeric: true }
                    ]}
                    rows={data.map(row => ({
                        columns: [
                            { value: row.ano },
                            { value: formatarValorMonetario(row.valor_total), numeric: true }
                        ]
                    }))}
                    total={{
                        label: "Total",
                        value: formatarValorMonetario(data.reduce((total, row) => total + row.valor_total, 0))
                    }}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogDetalheProps {
    open: boolean;
    data: IMovimentosPorAno[];
    handleClose: VoidFunction;
}
